import * as React from 'react';
import { Link } from 'react-router';
import { IUserPreferences } from 'models/user/userpreferences';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { AuthConsumer } from 'containers';
import { AvatarSmall } from 'components';
import renderIcon from 'helpers/renderIcon';
import { dropdown, IDropdownProps, closeAllDropdowns } from 'helpers/hooks';

interface IProps extends IDropdownProps {
	userPreferences: IUserPreferences;
	baseUrlClient: string;
	userAvatarRef?: React.RefObject<HTMLDivElement>;
	t?: (x: string) => string;
	getUserCard?: (id: string) => any;
	getShopCard?: (id: string) => any;
}

@dropdown()
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class UserMenu extends React.Component<IProps> {
	constructor(props) {
		super(props);

		this.goToMyProfile = this.goToMyProfile.bind(this);
		this.goToMyShop = this.goToMyShop.bind(this);
	}
	private goToMyProfile(e: any) {
		e.preventDefault();
		closeAllDropdowns();
		this.props.getUserCard(this.props.userPreferences.id);
	}

	private goToMyShop(e: any, id: string) {
		e.preventDefault();
		closeAllDropdowns();
		this.props.getShopCard(id);
	}

	private handleOnLogoutClick(e, logout) {
		e.preventDefault();
		closeAllDropdowns();
		logout();
	}

	public render() {
		const { t, open, toggle } = this.props;
		const { id, /*userShops,*/ isAdministrator /*isEditor*/ } = this.props.userPreferences;

		const loggedInMenuItems: JSX.Element[] = [];
		if (id !== null) {
			// to my profile
			loggedInMenuItems.push(
				<a key="usermenu_gotoprofile" href="#" onClick={this.goToMyProfile}>
					<AvatarSmall item={this.props.userPreferences} />
					<span>{t('Navigation_Main_UserMenu_MyProfile')}</span>
				</a>,
			);

			// dashboard link
			if (isAdministrator) {
				loggedInMenuItems.push(
					<Link onClick={closeAllDropdowns} key="usermenu_gotodashboard" to="/admin" className="d-block-sm">
						<figure>{renderIcon('pfp_default')}</figure>
						<span>{t('Admin_Breadcrumb_Admin')}</span>
					</Link>,
				);
			}

			// TASK 8631 replace orders page with appointments page
			// appointments
			loggedInMenuItems.push(
				<Link key="usermenu_appointments" to={`/profile/${id}?tab=appointments`}>
					<figure>{renderIcon('orders')}</figure>
					<span>{t('Navigation_Main_UserMenu_Appointments')}</span>
				</Link>,
			);

			//profile settings
			loggedInMenuItems.push(
				<Link onClick={closeAllDropdowns} key="usermenu_gotoprofilesettings" to="/userprofile">
					<figure>{renderIcon('edit_profile')}</figure>
					<span>{t('Navigation_Main_UserMenu_Settings')}</span>
				</Link>,
			);
		}

		return (
			<AuthConsumer>
				{({ logout }) => {
					return (
						<div className="dropdownHolder userMenuHolder" ref={this.props.ref1}>
							<div className="iconBtn" title={t('Navigation_Main_UserMenu_MyProfile')} onClick={toggle}>
								<AvatarSmall item={this.props.userPreferences} />
							</div>
							<div className="dropdown profileDropdown right" style={{ display: open ? 'block' : 'none' }}>
								<button className="backButton textBtn" type="button" onClick={toggle}>
									{renderIcon('back')}
									<span>{t('Navigation_Main_UserMenu_MyProfile')}</span>
								</button>
								<div className="dropdownList">
									{loggedInMenuItems}
									<a href="#" onClick={(e) => this.handleOnLogoutClick(e, logout)}>
										<figure>{renderIcon('log_out')}</figure>
										<span>{t('Navigation_Main_UserMenu_Logout')}</span>
									</a>
								</div>
							</div>
						</div>
					);
				}}
			</AuthConsumer>
		);
	}
}
export { UserMenu };
